import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import one from '../assets/1.png';
import two from '../assets/2.png';
import three from '../assets/3.png';
import four from '../assets/4.png';
import { useMediaQuery } from 'react-responsive';

const bannerStyles = {
  container: {
    position: 'relative',
    width: '100%',
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to right, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.2) 100%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 8%',
    zIndex: 2,
  },
  heading: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(1.8rem, 4vw, 3.2rem)',
    fontWeight: 700,
    color: '#FFFFFF',
    marginBottom: 16,
    lineHeight: 1.2,
    textShadow: '0 2px 8px rgba(0,0,0,0.3)',
    maxWidth: 550,
  },
  subtext: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: 'clamp(0.85rem, 1.5vw, 1.05rem)',
    color: 'rgba(255,255,255,0.9)',
    marginBottom: 28,
    maxWidth: 480,
    lineHeight: 1.6,
  },
  btnGroup: {
    display: 'flex',
    gap: 14,
    flexWrap: 'wrap',
  },
  btnPrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 28px',
    backgroundColor: '#C0844A',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 6,
    fontSize: '0.95rem',
    fontWeight: 600,
    fontFamily: "'Poppins', sans-serif",
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
  },
  btnOutline: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '12px 28px',
    backgroundColor: 'transparent',
    color: '#FFFFFF',
    border: '2px solid rgba(255,255,255,0.7)',
    borderRadius: 6,
    fontSize: '0.95rem',
    fontWeight: 500,
    fontFamily: "'Poppins', sans-serif",
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};

export default function SlidingBanner() {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 783px)' });

  const scrollToAvailability = () => {
    const el = document.getElementById('availability');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToGallery = () => {
    const el = document.getElementById('gallery');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div style={bannerStyles.container}>
      <Carousel
        style={{ height: isTabletOrMobile ? 350 : 500 }}
        controls={true}
        indicators={false}
        interval={4000}
        fade
      >
        <Carousel.Item style={{ height: isTabletOrMobile ? 350 : 500 }}>
          <img className="d-block w-100" src={one} alt="Convention hall view 1" style={bannerStyles.image} />
        </Carousel.Item>
        <Carousel.Item style={{ height: isTabletOrMobile ? 350 : 500 }}>
          <img className="d-block w-100" src={two} alt="Convention hall view 2" style={bannerStyles.image} />
        </Carousel.Item>
        <Carousel.Item style={{ height: isTabletOrMobile ? 350 : 500 }}>
          <img className="d-block w-100" src={three} alt="Convention hall view 3" style={bannerStyles.image} />
        </Carousel.Item>
        <Carousel.Item style={{ height: isTabletOrMobile ? 350 : 500 }}>
          <img className="d-block w-100" src={four} alt="Convention hall view 4" style={bannerStyles.image} />
        </Carousel.Item>
      </Carousel>

      {/* Text Overlay */}
      <div style={{
        ...bannerStyles.overlay,
        height: isTabletOrMobile ? 350 : 500,
        top: 0,
        pointerEvents: 'none',
      }}>
        <h1 style={bannerStyles.heading}>
          Create Unforgettable Moments
        </h1>
        <p style={bannerStyles.subtext}>
          Experience luxury and elegance at Gowri Prasanna Convention Hall. The
          perfect venue for your special occasions.
        </p>
        <div style={{ ...bannerStyles.btnGroup, pointerEvents: 'auto' }}>
          <button
            style={bannerStyles.btnPrimary}
            onClick={scrollToAvailability}
            onMouseEnter={e => { e.target.style.backgroundColor = '#A06B35'; e.target.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.target.style.backgroundColor = '#C0844A'; e.target.style.transform = 'translateY(0)'; }}
          >
            Book Your Event →
          </button>
          <button
            style={bannerStyles.btnOutline}
            onClick={scrollToGallery}
            onMouseEnter={e => { e.target.style.backgroundColor = 'rgba(255,255,255,0.15)'; }}
            onMouseLeave={e => { e.target.style.backgroundColor = 'transparent'; }}
          >
            View Gallery
          </button>
        </div>
      </div>
    </div>
  );
}
